import {useEffect} from "react";
import {checkGroup, isStaffMember} from "../../utils/permissions";
import {useAuth} from "../../contexts/AuthContext";
import env from "react-dotenv";

export default function WonderChatScript() {
    const {currentUser} = useAuth();
    const canViewChatWidget = checkGroup("Leitung", currentUser) || isStaffMember(currentUser)

    useEffect(() => {
        if (currentUser && env.SCHOOL === "KPI" && canViewChatWidget) {
            const script = document.createElement("script");
            script.src = "https://app.wonderchat.io/scripts/wonderchat.js";
            script.dataset.name = "wonderchat";
            script.dataset.address = "app.wonderchat.io";
            script.dataset.id = "cm5vguvt700c391hbqob8rl1m";
            script.dataset.widgetSize = "normal";
            script.dataset.widgetButtonSize = "normal";
            script.dataset.movable = "true";
            script.defer = true;

            // script.src = "https://app.wonderchat.io/scripts/wonderchat-searchbar.js";
            // script.async = true;
            // script.setAttribute("chatbotId", "cm5vguvt700c391hbqob8rl1m");

            document.body.appendChild(script);

            return () => {
                script.parentNode?.removeChild(script);
                // Note: iframe gets removed in logout() function in AuthContext.js
            };
        }
    }, [currentUser]);

    return null; // This component only injects the script
}
